import * as React from "react";
import { Box } from "@mui/material";
import CardItem from "./CardItem";

const CardList = ({ data }) => {
  return (
    <Box>
      {data.map((item, index) => (
        <Box
          key={index}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          padding={1}
        >
          <CardItem data={item} />
        </Box>
      ))}
    </Box>
  );
};

export default CardList;
